import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import React from 'react';
import { setBusinessDetailMenuItem } from 'state/business/actions';
import BusinessProfile from './BusinessProfile';
import styles from './BusinessDetailSections.module.css';
import RecurringPaymentTransactions from './RecurringPaymentTransactions';
import RecurringPaymentHistory from './RecurringPaymentHistory';

const BusinessSection = props => {
  const { businessDetailMenuItem, dispatch } = props;

  const handleBusinessTabItemClick = (e, { name }) => {
    dispatch(setBusinessDetailMenuItem(name));
  };

  return (
    <div className={styles.section}>
      <Grid>
        <Grid.Column stretched width={3}>
          <Menu fluid vertical tabular>
            <Menu.Item
              name="profile"
              active={businessDetailMenuItem === 'profile'}
              onClick={handleBusinessTabItemClick}
            />
          </Menu>
        </Grid.Column>
        <Grid.Column stretched width={13}>
          <div className={styles['item-component']}>
            <Segment>
              {(() => {
                switch (businessDetailMenuItem) {
                  case 'profile':
                    return <BusinessProfile />;
                  case 'Recurring Payment History':
                    return <RecurringPaymentHistory />;
                  case 'Recurring Payment Transactions':
                    return <RecurringPaymentTransactions />;
                  default:
                    return <></>;
                }
              })()}
            </Segment>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

const mapStateToProps = ({ business }) => ({
  businessDetailMenuItem: business.businessDetailMenuItem,
});

BusinessSection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  businessDetailMenuItem: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(BusinessSection);
